module.exports = __webpack_public_path__ + "img/freeTruck.d98883ba.svg";